export default __webpack_public_path__ + "static/media/image1.7a70187f.png";